import {HttpParams} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  FcGenericItemType,
  FcModifyGenericItemType,
  FindControlDeleteItemResultDto,
  FindControlInitDto,
  FindControlResultDto,
  GetDataSearchDto,
  GetMfuSearchDto,
  GetMruSearchDto,
  IColumnPk,
} from 'webcommon/shared';
import { PrmHttpClientService } from '../PrmHttpClientService';

@Injectable({
  providedIn: 'root',
})
export class FindControlRepository {
  constructor(
    private httpClientService: PrmHttpClientService,
  ) { }

  routePrefix = 'findcontrol/id';

  getConfig(id: string): Observable<FindControlInitDto> {
    const endpointUrl = `${this.routePrefix}/${id}/initialize`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }

  getData(id: string, searchDto: GetDataSearchDto): Observable<FindControlResultDto> {
    const endpointUrl = `${this.routePrefix}/${id}/search`;
    return this.httpClientService.sendPostRequest(endpointUrl, searchDto);
  }

  getSelectedItems(id: string, guids: string[]): Observable<FindControlResultDto> {
    const endpointUrl = `${this.routePrefix}/${id}/selecteditems`;
    return this.httpClientService.sendPostRequest(endpointUrl, guids);
  }

  getItem(id: string, itemPk: string): Observable<FcGenericItemType> {
    const endpointUrl = `${this.routePrefix}/${id}/item/${itemPk}`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }
  updateItem(id: string, itemPk: string, itemDto: FcModifyGenericItemType): Observable<IColumnPk> {
    const endpointUrl = `${this.routePrefix}/${id}/item/${itemPk}`;
    return this.httpClientService.sendPutRequest(endpointUrl, itemDto);
  }
  createItem(id: string, itemDto: FcModifyGenericItemType): Observable<IColumnPk> {
    const endpointUrl = `${this.routePrefix}/${id}/item`;
    return this.httpClientService.sendPutRequest(endpointUrl, itemDto);
  }

  getMruList(id: string, maxrows: number, searchDto: GetMruSearchDto): Observable<FindControlResultDto> {
    const endpointUrl = `${this.routePrefix}/${id}/mrulist`;
    let params = new HttpParams();
    params = params.set('maxRows', '' + maxrows);
    return this.httpClientService.sendPostRequest(endpointUrl, searchDto, params);
  }

  getMfuList(id: string, maxrows: number, searchDto: GetMfuSearchDto): Observable<FindControlResultDto> {
    const endpointUrl = `${this.routePrefix}/${id}/mfulist`;
    let params = new HttpParams();
    params = params.set('maxRows', '' + maxrows);
    return this.httpClientService.sendPostRequest(endpointUrl, searchDto, params);
  }

  updateMfuMruList(id: string, guids: string[]): Observable<string[]> {
    const endpointUrl = `${this.routePrefix}/${id}/updatemfumru`;
    return this.httpClientService.sendPostRequest(endpointUrl, guids);
  }

  deleteItem(id: string, controlId: string): Observable<FindControlDeleteItemResultDto> {
    const endpointUrl = `${this.routePrefix}/${id}/delete/${controlId}`;
    return this.httpClientService.sendDeleteRequest(endpointUrl);
  }

  canDeleteItem(id: string, controlId: string): Observable<FindControlDeleteItemResultDto> {
    const endpointUrl = `${this.routePrefix}/${id}/can-delete/${controlId}`;
    return this.httpClientService.sendDeleteRequest(endpointUrl);
  }

  mergeItem(id: string, controlId: string, newId: string): Observable<FindControlDeleteItemResultDto> {
    const endpointUrl = `${this.routePrefix}/${id}/merge/${controlId}`;
    let params = new HttpParams();
    params = params.set('newId', '' + newId);
    return this.httpClientService.sendDeleteRequest(endpointUrl, params);
  }
}
